<template>
  <div class="bg-white data-table table-responsive">
    <b-table
      show-empty
      :items="getFilteredItems"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      class="mb-1"
      :busy="busy"
      :empty-text="$t('DataTable.NoRecords')"
    >
      <template v-for="(x, slotName) in $scopedSlots" v-slot:[slotName]="context">
        <slot :name="slotName" v-bind="context" />
      </template>
      <template :slot="'HEAD_' + field.key" slot-scope="row" v-for="field in fields">
        <div :key="field.key">
          <div class="label" :style="[labelStyle ? labelStyle : '']">
            {{ $t(field.label) }}
          </div>
          <div v-if="searchable" class="input">
            <input
              type="text"
              class="form-control search-input"
              v-model="field.__searchValue"
              v-if="field._searchable"
              @input="onSearchValueChange(field)"
              :disabled="!field._searchable"
              :placeholder="$t('Search')"
            />
            <div v-else class="searchFieldHiding"></div>
          </div>
          <!-- <i
            class="icon icon-arrow-top sort-icon"
            v-if="alreadySorted(field) && field._sortDirection == 'asc' && field._sortable"
            @click="onSortDirectionChange(field, 'desc')"
          ></i>
          <i
            class="icon icon-arrow-bottom sort-icon"
            v-if="alreadySorted(field) && field._sortDirection == 'desc' && field._sortable"
            @click="onSortDirectionChange(field, 'asc')"
          ></i>
          <i
            class="fas fa-arrows-alt-v sort-icon"
            v-if="!alreadySorted(field) && field._sortable"
            @click="onSortDirectionChange(field, 'asc')"
          ></i> -->
        </div>
      </template>
      <template :slot="field.key" slot-scope="row" v-for="field in fields">
        <slot :name="field.key" :row="row"></slot>
      </template>
      <template slot="row-details" slot-scope="row">
        <slot name="row-details" :row="row"></slot>
      </template>
      <div slot="table-busy" class="text-center mt-3">
        <loading-icon></loading-icon>
        <div class="mt-3" style="font-size: 20px;">{{ $t('Loading') }}</div>
      </div>
    </b-table>
    <b-pagination
      v-if="items.length > 0 && items.length > perPage"
      v-model="currentPage"
      :total-rows="items.length"
      :per-page="perPage"
      class="pt-2 pb-2 pl-3"
    ></b-pagination>
  </div>
</template>

<script>
import filter from 'lodash/filter';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import values from 'lodash/values';
import LoadingIcon from './LoadingIcon';
import { BTable, BPagination } from 'bootstrap-vue';

export default {
  props: ['items', 'fields', 'perPage', 'busy', 'labelStyle', 'searchable'],
  components: {
    LoadingIcon,
    BTable,
    BPagination,
  },
  computed: {
    getFilteredItems() {
      if (Object.keys(this.filters).length > 0) {
        return this.doSort(
          filter(this.items, (row) => {
            let exists = false;
            for (let key in this.filters) {
              const field = this.filters[key];
              const __searchValue = field.__searchValue;
              let accessedValue = get(row, field.key);
              if (accessedValue) {
                if (_.isNumber(accessedValue)) {
                  accessedValue = '' + accessedValue;
                }
                if (accessedValue.toLowerCase().includes(__searchValue.toLowerCase())) {
                  exists = true;
                } else {
                  exists = false;
                  break;
                }
              }

              // exists.push(row[key].indexOf(__searchValue) > 0)
            }
            if (exists) {
              this.currentPage = 1;
            }
            return exists;
          }),
        );
      } else {
        // return original items
        return this.doSort(this.items);
      }
    },
  },
  data() {
    return {
      currentPage: 1,
      filters: {},
      sorts: [],
    };
  },
  watch: {
    items() {
      this.currentPage = 1;
    },
  },
  methods: {
    onSearchValueChange(field) {
      if (!field.__searchValue) {
        this.$delete(this.filters, field.key);
      } else {
        this.$set(this.filters, field.key, field);
      }
      this.currentPage = 1;
    },
    onSortDirectionChange(field, _sortDirection) {
      field._sortDirection = _sortDirection;
      field.clickCount = (field.clickCount || 0) + 1;
      if (field.clickCount % 3 === 0) {
        this.$delete(this.sorts, field.key);
      } else {
        this.$set(this.sorts, field.key, field);
      }
    },
    alreadySorted(field) {
      return !!this.sorts[field.key];
    },
    doSort(array) {
      const sortsArray = values(this.sorts);
      if (sortsArray.length > 0) {
        return orderBy(
          array,
          sortsArray.map((f) => (f._internalSortKey ? f._internalSortKey : f.key)),
          sortsArray.map((f) => f._sortDirection),
        );
      }
      return array;
    },
  },
  created() {
    // initialize default sorting
    const fieldsWithDefaultSort = this.fields.filter((r) => r._sortDirection);
    if (fieldsWithDefaultSort && fieldsWithDefaultSort.length > 0) {
      fieldsWithDefaultSort.map((field) => {
        this.onSortDirectionChange(field, field._sortDirection);
      });
    }
  },
};
</script>

<style lang="scss">
@import '../../sass/variables';

.data-table {
  table {
    border-collapse: collapse;
    width: 100%;
    table-layout: auto;

    thead {
      tr {
        th {
          padding: 0;
          margin: 0;
          border-bottom: none;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;

          .label {
            min-width: 100px;
            background-color: $secondary-bg-color;
            color: white;
            padding: 10px;
            border: 1px solid $secondary-bg-color;
            @media (max-width: 992px) {
              padding: 10px 20px 15px 20px;
            }
          }

          .input {
            padding: 10px;
            border-left: 1px solid #e8e8e8;
            border-bottom: none;

            .search-input {
              width: 100%;
            }
            .searchFieldHiding {
              display: block;
              width: 100%;
              height: calc(1.5em + 0.75rem + 2px);
              padding: 0.375rem 0.75rem;
              background-clip: padding-box;
            }
          }

          .sort-icon {
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
            transition: all 0.2s ease-in-out;
            font-size: 12px;
            color: white;

            &:hover {
              color: $dark-blue-grey;
            }
          }

          &:first-child {
            text-align: left !important;
          }
        }
      }
    }

    tbody {
      tr {
        font-weight: 700;
        &.b-table-details {
          // TODO: accordion animation
        }

        &.b-table-has-details {
          color: var(--color3);
          border-left: 5px solid var(--color3) !important;

          td {
          }
        }

        td {
          border: 1px solid #e8e8e8;
          vertical-align: middle;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding: 5px 22px;

          @media only screen and (max-width: 1600px) {
            padding: 5px 7px;
            font-size: 13px;
          }
        }
      }
    }
  }

  .page-link {
    padding: 15px 22px;
    color: $active-color;
  }

  .page-item.active {
    .page-link {
      background-color: $active-color;
      border-color: $active-color;
    }
  }

  .page-item:first-child,
  .page-item:last-child {
    display: none;
  }
}
</style>
